import { Cart } from 'shared/types/cart';

export const isAValidDiscontinuedVariant = ({
  availableQuantity,
  cart,
  quantityToAdd,
  variantSku,
}: {
  variantSku: string;
  cart: Cart;
  quantityToAdd: number;
  availableQuantity: number;
}): boolean => {
  // Find current sku in Cart
  const variantInCart = cart.lineItems?.find((lineItem) => lineItem.variant?.sku === variantSku);

  if (!variantInCart) {
    return true;
  }

  const quantityItemsInCart = variantInCart.count ?? 0;

  // Sum
  const futureQuantity = quantityToAdd + quantityItemsInCart;

  if (futureQuantity > availableQuantity) {
    return false;
  }

  return true;
};
